import api from "../../index.js";

export const GetIBTeamApi = (params) => api.get(`UserMaster/IBTeam?${params}`);
export const GetUserDetailsByIdApi = (params) => api.get(`IBMaster/GetIBUser-AccountList?UserId=${params}`);